import {
  Col,
  Modal,
  Row,
  Input,
  Button,
  Switch,
  Tag,
  Select,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import "../../styles/components.scss";
import { Header } from "../../components/Header";
import { FormattedMessage } from "react-intl";
import {
  toAddUser,
  toChangeStatus,
  toChangeSales,
  toGetUsers,
  toUpdateCountriesInUser,
  toChangeDSO,
  toChangePP,
} from "../../utils/APIs";
import countries from "../../data/countries.json";
import { getLanguage, tagRender } from "../../utils/Utils";
import ScreenLoader from "../../components/ScreenLoader";

const language = getLanguage();

const UserManagement = () => {
  const [email, setEmail] = useState("");
  const [checkedSales, setCheckedSales] = useState(true);
  const [dso, setDSO] = useState(true);
  const [pp, setPP] = useState(true);
  const [selectedEmail, setSelectedEmail] = useState("");
  const [users, setUsers] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [displayEmailError, setDisplayEmailError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    toGetUsers().then((res) => {
      setUsers(res);
    });
  }, []);

  const getCountryName = (country) => {
    return language == "fr" ? country.title_fr : country.title_en;
  };

  const getCountries = (ids, user) => {
    var res = [];
    ids.forEach((id) => {
      res.push(getCountryName(countries.find((a) => a.id == id)));
    });

    return res;
  };

  const getCountryId = (name) => {
    var index = -1;
    if (language == "fr") {
      index = countries.findIndex((a) => a.title_fr == name);
    } else {
      index = countries.findIndex((a) => a.title_en == name);
    }
    return countries[index].id;
  };

  const onChange = (e) => {
    var l__array = [];
    e.forEach((element) => {
      l__array.push(getCountryId(element));
    });
    setSelectedIds(l__array);
  };

  const onChangeInList = (id, e) => {
    var l__array = [];
    e.forEach((element) => {
      l__array.push(getCountryId(element));
    });

    toUpdateCountriesInUser(id, l__array);
  };

  const addUser = () => {
    if (!email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
      setDisplayEmailError(true);
      return;
    }
    setDisplayEmailError(false);

    toAddUser(email, selectedIds, checkedSales, dso, pp).then(() => {
      setLoading(true);
      setEmail("");
      setUsers([]);

      toGetUsers().then((res) => {
        setUsers(res);
        setTimeout(() => {
          setLoading(false);
        }, 200);
      });
    });
  };
  const onChangeSwitch = (username) => {
    let newUsers = [...users];
    const itemIndex = newUsers.findIndex((u) => u.username == username);

    newUsers[itemIndex].actif = !newUsers[itemIndex].actif;
    setUsers(newUsers);
    setSelectedEmail(username);
    setIsModalVisible(true);
  };

  const onChangeSwitchSale = (username) => {
    let newUsers = [...users];
    const itemIndex = newUsers.findIndex((u) => u.username == username);
    newUsers[itemIndex].sales__team = !newUsers[itemIndex].sales__team;

    setUsers(newUsers);
    toChangeSales(username).then(() => {});
  };

  const onChangeSwitchDSO = (username) => {
    toChangeDSO(username).then(() => {
      let newUsers = [...users];
      const itemIndex = newUsers.findIndex((u) => u.username == username);

      newUsers[itemIndex].d__sO = !newUsers[itemIndex].d__sO;
      setUsers(newUsers);
    });
  };

  const onChangeSwitchPP = (username) => {
    toChangePP(username).then(() => {
      let newUsers = [...users];
      const itemIndex = newUsers.findIndex((u) => u.username == username);

      newUsers[itemIndex].p__p = !newUsers[itemIndex].p__p;
      setUsers(newUsers);
    });
  };

  const onYesClick = () => {
    toChangeStatus(selectedEmail).then(() => {
      setIsModalVisible(false);
    });
  };
  const noClicked = () => {
    let newUsers = [...users];
    const itemIndex = newUsers.findIndex((u) => u.username == selectedEmail);
    newUsers[itemIndex].actif = !newUsers[itemIndex].actif;
    setUsers(newUsers);
    setIsModalVisible(false);
    setSelectedEmail("");
  };

  const getStatus = (username) => {
    if (username != "") {
      const userIndex = users.findIndex((u) => u.username == username);
      return users[userIndex].actif;
    }
  };
  const modalConfirm = (
    <Modal
      footer={null}
      style={{ top: 300 }}
      width={"80vh"}
      visible={isModalVisible}
      onCancel={() => noClicked()}
    >
      <div style={{ marginTop: "4vh", textAlign: "center" }}>
        <span className="roi--text-popup">
          {getStatus(selectedEmail) ? (
            <>
              <FormattedMessage id="toReactivate" />{" "}
            </>
          ) : (
            <>
              <FormattedMessage id="toDeactivate" />
            </>
          )}
          {selectedEmail}
        </span>
        <Row style={{ textAlign: "center", marginTop: "4vh" }}>
          <Col span={12}>
            <Button
              className="roi--button-primary"
              onClick={() => onYesClick()}
              style={{ minHeight: "5vh", width: "30vh" }}
            >
              <FormattedMessage id="yes" />
            </Button>
          </Col>
          <Col span={12}>
            <Button
              className="roi--button-second"
              onClick={() => noClicked()}
              style={{ minHeight: "5vh", width: "30vh" }}
            >
              <FormattedMessage id="no" />
            </Button>
          </Col>
        </Row>
      </div>
    </Modal>
  );
  return (
    <>
      <Header />

      <div style={{ textAlign: "center", marginTop: "10vh" }}>
        <Typography.Title level={2} className="roi--title-admin">
          <FormattedMessage id="userManagement" />
        </Typography.Title>
      </div>

      <div
        className="roi--background-section"
        style={{ marginTop: "5vh", paddingBottom: "4vh" }}
      >
        <Row className="roi--no-margin">
          <span
            className="roi--section-title roi--ml-four"
            style={{ marginTop: "2vh" }}
          >
            <FormattedMessage id="addUser" />
          </span>
        </Row>

        <Row style={{ marginTop: "2vh", marginRight: "0" }}>
          <Col span={8}>
            <span
              className="roi--label-section roi--ml-four"
              style={{ marginTop: "5vh" }}
            >
              <FormattedMessage id="enterEmail" />
            </span>
          </Col>
          <Col span={6}>
            <Input
              type="email"
              onChange={(e) => setEmail(e.target.value)}
              className={
                displayEmailError ? "roi--input roi--error-input" : "roi--input"
              }
            />
            <br />
            {displayEmailError ? (
              <label className="roi--access-denied">
                <FormattedMessage id="emailNotValid" />
              </label>
            ) : (
              <label className="roi--access-denied"></label>
            )}
          </Col>
        </Row>
        <Row style={{ marginTop: "2vh", marginRight: "0" }}>
          <Col span={8}>
            <span
              className="roi--label-section roi--ml-four"
              style={{ marginTop: "5vh" }}
            >
              <FormattedMessage id="countriesToDisplay" />
            </span>
          </Col>
          <Col span={6}>
            <Select
              mode="multiple"
              showArrow={false}
              onChange={(e) => onChange(e)}
              tagRender={tagRender}
              style={{ width: "100%" }}
            >
              {countries.map((country) => (
                <Select.Option
                  value={language == "fr" ? country.title_fr : country.title_en}
                >
                  {getCountryName(country)}
                </Select.Option>
              ))}
            </Select>
          </Col>
        </Row>
        <Row style={{ marginTop: "2vh", marginRight: "0" }}>
          <Col span={8}>
            <span
              className="roi--label-section roi--ml-four"
              style={{ marginTop: "5vh" }}
            >
              <FormattedMessage id="salesTeam" />
            </span>
          </Col>
          <Col span={6}>
            <Switch
              checkedChildren="Yes"
              unCheckedChildren="No"
              size={"large"}
              checked={checkedSales}
              onChange={() => setCheckedSales(!checkedSales)}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: "2vh", marginRight: "0" }}>
          <Col span={8}>
            <span
              className="roi--label-section roi--ml-four"
              style={{ marginTop: "5vh" }}
            >
              DSO
            </span>
          </Col>
          <Col span={6}>
            <Switch
              style={{ marginRight: "1vh" }}
              size={"large"}
              checked={dso}
              onChange={() => setDSO(!dso)}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: "2vh", marginRight: "0" }}>
          <Col span={8}>
            <span
              className="roi--label-section roi--ml-four"
              style={{ marginTop: "5vh" }}
            >
              PP
            </span>
          </Col>
          <Col span={6}>
            <Switch
              style={{ marginRight: "1vh" }}
              size={"large"}
              checked={pp}
              onChange={() => setPP(!pp)}
            />
          </Col>
        </Row>

        <Row justify="end" style={{ marginTop: "1vh", marginRight: "0" }}>
          <Button
            onClick={() => addUser()}
            className="roi--button-primary"
            style={{ minHeight: "4vh", width: "30vh" }}
          >
            <FormattedMessage id="save" />
          </Button>
        </Row>
      </div>
      <div
        className="roi--background-section"
        style={{ marginTop: "5vh", paddingBottom: "2vh" }}
      >
        <Row className="roi--no-margin">
          <span
            className="roi--section-title roi--ml-four"
            style={{ marginTop: "2vh" }}
          >
            <FormattedMessage id="listUser" />
          </span>
        </Row>
        {loading ? (
          <ScreenLoader />
        ) : (
          <>
            {users.map((user, index) => (
              <div key={index}>
                <Row style={{ marginTop: "2vh" }} key={index}>
                  <Col xl={6} md={6} style={{ marginTop: "1vh" }}>
                    <div>
                      <span className="roi--label-section roi--ml-four">
                        {user.username}
                        {user.type == "admin" && "(admin)"}
                      </span>
                      {/* <hr className="roi--hr" style={{ marginTop: "2vh" }} /> */}
                    </div>
                  </Col>
                  <Col xl={16} md={16}>
                    <hr className="roi--hr" style={{ marginTop: "2vh" }} />
                  </Col>
                  <Col
                    span={1}
                    style={{ marginTop: "1vh", textAlign: "right" }}
                  >
                    <Switch
                      checkedChildren="ON"
                      unCheckedChildren="OFF"
                      size={"large"}
                      checked={user.actif}
                      onChange={() => onChangeSwitch(user.username)}
                    />
                  </Col>
                </Row>
                {user.type == "user" && (
                  <Row
                    key={index}
                    style={{
                      marginTop: "2vh",
                      marginLeft: "2vh",
                      marginRight: "0",
                    }}
                  >
                    <Col xl={6} lg={6} md={8}>
                      <span
                        className="roi--label-section roi--ml-four"
                        style={{
                          marginTop: "5vh",
                          borderLeft: "1px solid rgb(84, 89, 110)",
                          paddingLeft: "10px",
                        }}
                      >
                        <FormattedMessage id="countriesToDisplay" />
                      </span>
                    </Col>
                    <Col xl={6} md={10}>
                      <Select
                        className="roi--select-text"
                        mode="multiple"
                        id={user.id}
                        onChange={(e) => onChangeInList(user.id, e)}
                        defaultValue={getCountries(user.countries, user)}
                        tagRender={tagRender}
                        style={{ width: "100%" }}
                        key={index}
                      >
                        {countries.map((country) => (
                          <Select.Option
                            value={
                              language == "fr"
                                ? country.title_fr
                                : country.title_en
                            }
                          >
                            {getCountryName(country)}
                          </Select.Option>
                        ))}
                      </Select>
                    </Col>
                  </Row>
                )}
                <Row
                  style={{
                    marginTop: "2vh",
                    marginLeft: "2vh",
                    marginRight: "0",
                  }}
                >
                  <Col xl={6} lg={6} md={8}>
                    <span
                      className="roi--label-section roi--ml-four"
                      style={{
                        marginTop: "5vh",
                        borderLeft: "1px solid rgb(84, 89, 110)",
                        paddingLeft: "10px",
                      }}
                    >
                      <FormattedMessage id="salesTeam" />
                    </span>
                  </Col>
                  <Col xl={6} md={10}>
                    <Col
                      span={1}
                      style={{ marginTop: "1vh", textAlign: "right" }}
                    >
                      <Switch
                        checkedChildren="Yes"
                        unCheckedChildren="No"
                        size={"large"}
                        checked={user.sales__team}
                        onChange={() => onChangeSwitchSale(user.username)}
                      />
                    </Col>
                  </Col>
                </Row>
                <Row
                  key={index}
                  style={{
                    marginTop: "2vh",
                    marginLeft: "2vh",
                    marginRight: "0",
                  }}
                >
                  <Col xl={6} lg={6} md={8}>
                    <span
                      className="roi--label-section roi--ml-four"
                      style={{
                        marginTop: "5vh",
                        borderLeft: "1px solid rgb(84, 89, 110)",
                        paddingLeft: "10px",
                      }}
                    >
                      DSO
                    </span>
                  </Col>
                  <Col xl={6} md={10}>
                    <Switch
                      style={{ marginRight: "1vh" }}
                      size={"large"}
                      checked={user.d__sO}
                      onChange={() => onChangeSwitchDSO(user.username)}
                    />
                  </Col>
                </Row>

                <Row
                  style={{
                    marginTop: "2vh",
                    marginLeft: "2vh",
                    marginRight: "0",
                  }}
                >
                  <Col xl={6} lg={6} md={8}>
                    <span
                      className="roi--label-section roi--ml-four"
                      style={{
                        marginTop: "5vh",
                        borderLeft: "1px solid rgb(84, 89, 110)",
                        paddingLeft: "10px",
                      }}
                    >
                      PP
                    </span>
                  </Col>
                  <Col xl={6} md={10}>
                    <Switch
                      style={{ marginRight: "1vh" }}
                      size={"large"}
                      checked={user.p__p}
                      onChange={() => onChangeSwitchPP(user.username)}
                    />
                  </Col>
                </Row>
              </div>
            ))}
          </>
        )}
        {modalConfirm}
      </div>
    </>
  );
};

export default UserManagement;
